import { DxDiagnosisResultAdviceContent } from '@src/api/types/shared/dxDiagnosis.ts';
import { brandColors } from '@src/assets/colors/brandColors';
import SvgIconNewTab from '@src/assets/images/common/icon/new-tab/SvgIconNewTab';
import { RecommendedSupportMenu } from '@src/features/company/dx-diagnosis/DxDiagnosisResultForm';

const Advice = ({
  adviceContent,
  recommendedSupportMenu,
}: {
  adviceContent: DxDiagnosisResultAdviceContent;
  recommendedSupportMenu: RecommendedSupportMenu[];
}) => {
  return (
    <>
      <div className='px-6'>
        <ol className='flex flex-col gap-5'>
          {adviceContent.items.map((item, index) => (
            <li
              className='flex flex-col gap-3'
              key={index}
            >
              <h3 className='border-b border-solid border-gray-200 pb-2 font-semibold text-primary-500'>
                {item.title}
              </h3>
              <ul className='list-outside list-disc pl-5 text-sm leading-[1.7]'>
                {item.descriptions.map((description, index) => (
                  <li key={index}>{description}</li>
                ))}
              </ul>
            </li>
          ))}
        </ol>
        <div className='mt-10'>
          <h3 className='mb-6 text-xl font-semibold'>具体的な次のステップ</h3>
          <ol className='flex flex-col gap-5'>
            {adviceContent.next_steps.map((step, index) => (
              <li
                className='flex flex-col gap-3'
                key={index}
              >
                <h3 className='border-b border-solid border-gray-200 pb-2 font-semibold text-primary-500'>
                  {step.title}
                </h3>
                <p className='text-sm leading-[1.7]'>{step.description}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
      <div className='mt-8'>
        <p className='rounded bg-primary-50 px-6 py-2 text-sm'>{adviceContent.summary}</p>
      </div>
      <div className='mt-10'>
        <h3 className='mb-6 text-xl font-semibold'>貴社へのおすすめの支援サービス</h3>
        <div className={`${recommendedSupportMenu?.length > 8 ? 'h-[300px] overflow-y-auto' : ''}`}>
          <ol className='flex flex-wrap gap-x-4 [&>li:nth-child(4n+1)]:bg-gray-10 [&>li:nth-child(4n+2)]:bg-gray-10'>
            {recommendedSupportMenu.map((menu, index) => (
              <li
                key={index}
                className='w-[calc(50%-8px)]'
              >
                <a
                  className='flex h-full items-center gap-4 px-6 py-[18px] transition-opacity hover:opacity-60'
                  href={menu.href}
                  target='_blank'
                >
                  <p className='whitespace-normal break-all text-sm text-primary'>{menu.title}</p>
                  <SvgIconNewTab
                    color={brandColors['500']}
                    className='flex-[0_0_auto]'
                  />
                </a>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </>
  );
};

export default Advice;
